import {type BlobRef} from '@atproto/lex'

export type ProfileLink = {
  url: string
  title?: string
  /**
   * The site's favicon, fetched through cardyb and uploaded when the link is
   * saved, so it goes through blob scanning like any other profile image.
   * Support links don't need one; they use bundled logos.
   */
  icon?: BlobRef
  /**
   * The icon's image URL, as returned in profile views. For an icon that was
   * just fetched and isn't saved yet, a data URI of it.
   */
  iconUrl?: string
  /** The `app.bsky.actor.link` record, once the link has been saved. */
  uri?: string
  cid?: string
  /** The original profile.website value, until this compatibility entry is saved. */
  legacyWebsite?: string
}

export type ProfileLinkRef = {uri: string; cid: string}

/** A repo snapshot, including refs omitted from the visible editor. */
export type OwnProfileLinks = {
  links: ProfileLink[]
  refs: ProfileLinkRef[]
  website?: string
  /** All resolved destinations, including links hidden by client validation. */
  urls: string[]
  /** An explicit save may update header order; a background editor load may not. */
  locallySaved?: boolean
}

export const MAX_PROFILE_LINKS = 10

/** Keeps a pill from swallowing the whole row. */
export const MAX_TITLE_LENGTH = 30
